import {
  LeftMenuClose,
  LeftMenuOpen,
  LEFT_MENU_ACTIONS_CLOSE,
  LEFT_MENU_ACTIONS_OPEN,
} from './LeftMenuActionTypes';

export function leftMenuActionsOpen(): LeftMenuOpen {
  return {
    type: LEFT_MENU_ACTIONS_OPEN,
    payload: true,
  };
}

export function leftMenuActionsClose(): LeftMenuClose {
  return {
    type: LEFT_MENU_ACTIONS_CLOSE,
    payload: false,
  };
}
